export default __webpack_public_path__ + "static/mobileapps-70c457da99a5c4c56b41b321969868c8.jpg";